// removed by extract-text-webpack-plugin
module.exports = {"root":"_24dK2QV"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/Accessibility/ScreenReaderOnly.less
 ** module id = 624
 ** module chunks = 0
 **/